import { getAuth0TokenBrowser } from "@/utils/auth0Browser";
import { makeRpcCall } from "../core/rpc.core";

export const callRpcBrowser = async <P, T>(
  method: string,
  params?: P,
  id: string = "1"
): Promise<T> => {
  const token = await getAuth0TokenBrowser();
  
  const headers: Record<string, string> = {};
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  return makeRpcCall<P, T>(
    method,
    params,
    headers,
    { credentials: "include" },
    id
  );
};
